import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { TableCustomers } from "./components/TableCustomers";
import { CatalogCustomer } from "@/shared/models/CatalogCustomer";
import { getCatalogCustomers } from "@/shared/repositories/CatalogCustomerRepository";

type useCatalogCustomersProps = {
	onError?: (error: Error) => void;
};

export const useCatalogCustomers = ({ onError }: useCatalogCustomersProps) => {
	return useQuery<CatalogCustomer[], Error>({
		queryKey: ["catalogCustomers"],
		queryFn: () => getCatalogCustomers(),
		onError: onError,
	});
};

export const CatalogCustomersPage = () => {
	return (
		<>
			<HelmetDexteel title="Customers - Configurations" />
			<TableCustomers />
		</>
	);
};
